let ParlseyEventsView = require("./ParsleyEventsView");
let errorsView = new ParlseyEventsView();

module.exports = {
    initialize: function (ajaxWrapper, redirect, webUrl, paymentView) {
        let displayErrors = (errors) => {
                errorsView.showFieldErrors(errors, $('#member-card-number'), 'member-card-number');
        };

        let onSuccess = (data) => {


            if (!data.serverError && data.inStorePaymentErrors && data.inStorePaymentErrors.length === 0) {
                redirect(webUrl);
            }
            else if (data.serverError) {

                document.getElementById("serverside-ajax-error-message").innerHTML = data.serverErrorMessage;
                $('#serverside-ajax-error').removeClass('errors-serverside--hidden');
                $('#serverside-ajax-error').get(0).scrollIntoView();
                paymentView.removeTempCardButtonLoading();

            }
            else {
                displayErrors(data.inStorePaymentErrors);
                paymentView.removeTempCardButtonLoading();
            }

        };

        let onSubmit = function(event) {
            event.preventDefault();

            errorsView.formValidate();
            paymentView.addTempCardButtonLoading();
            let cardNumber = document.getElementById('member-card-number').value;
            ajaxWrapper.call({
                type: 'POST',
                url: '/payment/in-store',
                data: {memberCardNumber: cardNumber},
                success: onSuccess,
                failure: () => {displayErrors(["Please try again later"]);}
            });
        };

        let tempCardDetails = document.getElementById('temporary-card-details');
        if(tempCardDetails) {
            document.getElementById('temporary-card-details').addEventListener('submit', onSubmit);
        }
   }
};
